<template>
  <div class="main-layout">
    <div>Admin users - name / email / type</div>
    <transition name="list" mode="out-in">
      <router-view class="container"></router-view>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'main-layout'
}
</script>

<style lang="scss" scoped>
.main-layout {
  top: 20px;
  position: relative;
  margin: auto;
  width: 1118px;

  /*border: 1px dotted gray;*/
  .top-bar {
    position: relative;
    margin: auto;
    width: 1080px;
  }

  .menu-under-bar {
    margin: 20px auto;
    width: 97%;
  }

  .container {
    position: relative;
    margin: 20px auto;
    width: 1080px;
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.1s ease-in-out;
}

.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */
 {
  opacity: 0;
  transform: translateX(30px);
}
</style>
